import axios from "../axios";

const base = "/inventory/valuation";

/** Amounts are decimal strings from the API. Keep them as strings. */
export const inventoryValuationApi = {
  getValuation: (params, config = {}) => axios.get(base, { ...config, params }),
  getMovements: (params, config = {}) => axios.get(`${base}/movements`, { ...config, params }),
  getCostAdjustments: (params, config = {}) => axios.get(`${base}/cost_adjustments`, { ...config, params }),
  getCostAdjustmentReceipts: (params, config = {}) => axios.get(`${base}/cost_adjustments/receipts`, { ...config, params }),
  createCostAdjustment: (cost_adjustment) => axios.post(`${base}/cost_adjustments`, { cost_adjustment }),
  getReconciliation: (params, config = {}) => axios.get(`${base}/reconciliation`, { ...config, params }),
  getAccountingBaselines: () => axios.get(`${base}/accounting_baselines`),
  createAccountingBaseline: (baseline) => axios.post(`${base}/accounting_baselines`, { baseline }),
  openingPreview: (effectiveDate) => axios.get(`${base}/opening_preview`, { params: { effective_date: effectiveDate } }),
  approveOpening: (opening) => axios.post(`${base}/opening`, { opening }),
  exportValuation: (params) => axios.post(`${base}/exports`, params),
  getExport: (id) => axios.get(`${base}/exports/${id}`),
  downloadExport: (id) => axios.get(`${base}/exports/${id}/download`, { responseType: "blob" }),
  downloadPdf: (params) => axios.get(`${base}/pdf`, {
    params,
    responseType: "blob",
    headers: { Accept: "application/pdf" },
  }),
};
